import { etapasEnum, etapasIndexEnum } from '@common/util/defaultValues';
export const atributosMedicoDetalhes = [
  {
    id: etapasIndexEnum.MACRO,
    etapa: etapasEnum.MACRO,
    medico: 'medMacro',
    revisor: 'revisorMacro',
    data: 'dtMacro'
  },
  {
    id: etapasIndexEnum.MICRO,
    etapa: etapasEnum.MICRO,
    medico: 'medMicro',
    revisor: 'revisorMicro',
    data: 'dtMicro'
  },
  {
    id: etapasIndexEnum.HISTO,
    etapa: etapasEnum.HISTO,
    medico: 'medHisto',
    revisor: 'revisorHisto',
    data: 'dtHisto'
  },
  {
    id: etapasIndexEnum.IMUNO,
    etapa: etapasEnum.IMUNO,
    medico: 'medImuno',
    revisor: 'revisorImuno',
    data: 'dtImuno'
  },
  {
    id: etapasIndexEnum.FISH,
    etapa: etapasEnum.FISH,
    medico: 'medFish',
    revisor: 'revisorFish',
    data: 'dtFish'
  },
  {
    id: etapasIndexEnum.CISH,
    etapa: etapasEnum.CISH,
    medico: 'medCish',
    revisor: 'revisorCish',
    data: 'dtCish'
  },
  {
    id: etapasIndexEnum.PCR,
    etapa: etapasEnum.PCR,
    medico: 'medPcr',
    revisor: 'revisorPcr',
    data: 'dtPcr'
  },
  {
    id: etapasIndexEnum.CONGELACAO,
    etapa: etapasEnum.CONGELACAO,
    medico: 'medCongelacao',
    data: 'dtCongelacao',
    revisor: null
  },
  {
    id: etapasIndexEnum.NOTAS,
    etapa: etapasEnum.NOTAS,
    medico: 'medNotas',
    data: 'dtNotas',
    revisor: 'revisorNotas'
  },
  {
    id: etapasIndexEnum.CONCLUSAO,
    etapa: etapasEnum.CONCLUSAO,
    medico: 'medConclusao',
    revisor: 'revisorConclusao',
    data: 'dtConclusao'
  },
  {
    id: etapasIndexEnum.ERRATA,
    etapa: etapasEnum.ERRATA,
    medico: 'medErrata',
    data: 'dtErrata',
    revisor: 'revisorErrata'
  }
];



// WEBPACK FOOTER //
// ./src/pages/laudo/detalhesExame/detalhes.utils.js